import { handleActions } from 'redux-actions';
import { combineReducers } from 'redux';
import { copyPrevMonth, copyPrevMonthFailure, copyPrevMonthIdle, copyPrevMonthSuccess } from '../actions';

const status_copy_prev_month = handleActions(
  {
    [copyPrevMonth.toString()]: (state, action) => 'LOADING',
    [copyPrevMonthSuccess.toString()]: (state, action) => 'SUCCESS',
    [copyPrevMonthFailure.toString()]: (state, action) => 'FAILURE',
    [copyPrevMonthIdle.toString()]: (state, action) => 'IDLE',
  },
  'IDLE'
);

export { status_copy_prev_month };
